/* @flow */
import ParamsLink from 'components/Links/ParamsLink';

import type { ThProps } from './types';

const baseStyle = {
  color: '#565656',
  backgroundColor: '#fafafa',
  display: 'table-cell',
  fontSize: '13px',
  fontWeight: 'normal',
  padding: '0 .5rem',
  textAlign: 'left',
  verticalAlign: 'middle',
};

const arrow = (d: string): React.Element => (
  <svg
    focusable="false"
    height="8px"
    viewBox="0 0 7 8"
    width="7px"
    x="0px"
    y="0px"
    >
    <path fill="#000000" d={d} />
  </svg>
);

function descArrow(): React.Element {
  return arrow('M2.984,0v6L0.681,4l-0.689,0.72l3.536,3.289l3.464-3.273L6.241,4L3.984,6L3.969,0H2.984z');
}

function ascArrow(): React.Element {
  return arrow('m 4,8.009 0,-6 2.303,2 L 6.992,3.289 3.456,0 -0.008,3.273 0.743,4.009 3,2.009 l 0.015,6 0.985,0 z');
}

export default function Th({
  children,
  colSpan,
  field,
  order,
  sort,
  sortable,
  useSortBy,
  style,
}: ThProps): React.Element {
  const sorted = typeof field !== 'undefined' && sort === field;
  const reverse = (sorted && order === 'desc') ? 'asc' : 'desc';
  const sorting = useSortBy
    ? { sort_by: `${field}:${reverse}` }
    : {
      sort: field,
      order: reverse,
    };

  return (
    <th
      colSpan={colSpan}
      style={{
        ...baseStyle,
        textDecoration: sortable ? 'underline' : 'none',
        fontWeight: sorted ? 'bold' : 'normal',
        ...style,
      }}
      >
      {sortable
        ? (
          <ParamsLink
            query={{
              offset: 0,
              ...sorting,
            }}
            >
            {children}
          </ParamsLink>
        )
        : children}

      {sorted && (
        <span style={{ marginLeft: '.5rem' }}>
          {order === 'asc' ? ascArrow() : descArrow()}
        </span>
      )}
    </th>
  );
}
